import styled from "styled-components";

import { IStyledAttributes } from "@ryde/shared";
import { rydeColors } from "@ryde/theme";

export const TooltipContentStyled = styled.div.attrs<IStyledAttributes>({
  "data-e2e": "availability-tooltip-content",
})`
  .tooltip-entry {
    &:not(:first-child) {
      margin-top: 8px;
      padding-top: 8px;
      border-top: 1px solid rgba(255, 255, 255, 0.2);
    }
  }

  .tooltip-time {
    font-weight: 600;
    margin-bottom: 4px;
  }

  .tooltip-section {
    max-width: 180px;

    &:not(:first-child) {
      margin-top: 4px;
    }
  }

  .tooltip-section-label {
    font-weight: 500;
  }
`;

export const CellContentStyled = styled.div.attrs<IStyledAttributes>({
  "data-e2e": "availability-cell-content",
})`
  display: flex;
  align-items: center;
  overflow: hidden;
  min-width: 0;
`;

export const DisplayTextStyled = styled.span.attrs<IStyledAttributes>({
  "data-e2e": "availability-display-text",
})`
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const RestCountStyled = styled.span.attrs<IStyledAttributes>({
  "data-e2e": "availability-rest-count",
})`
  color: ${rydeColors.lightBlue};
  font-weight: 400;
  margin-inline-start: 4px;
  flex-shrink: 0;
`;
